// Rates & boletos
import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatPriceByLocale } from '../../../lib/utils';

export default function RateAndBoletos({ occupant }: any) {
    const { t } = useTranslation();

    return (
        <>
            <Box>
                {t('booking.rate')} / {t('booking.bono')}
            </Box>

            {occupant.fares ? (
                <Box mt={1}>
                    {/* --- Rate --- */}
                    {occupant.selectedRate &&
                        occupant.selectedRate.prices.map((price: any) => (
                            <Chip
                                key={price.id || price.name}
                                color="primary"
                                style={{
                                    marginRight: 3,
                                    marginTop: 3,
                                    color: 'white',
                                    backgroundColor: '#5b7fff',
                                }}
                                size="small"
                                label={`${price.name} [ ${
                                    price.duration
                                }m / ${formatPriceByLocale(
                                    price?.price,
                                    price?.priceShape?.currency,
                                    price?.priceShape?.locale,
                                )} ]`}
                            />
                        ))}

                    {/* --- Boleto --- */}
                    {occupant.selectedBoleto && (
                        <Chip
                            style={{
                                marginRight: 3,
                                marginTop: 3,
                                color: 'white',
                                backgroundColor: '#f576f7',
                            }}
                            color="primary"
                            size="small"
                            label={`${occupant.selectedBoleto.bono.name}
							[ ${occupant.selectedBoleto.consumed} / ${occupant.selectedBoleto.amount} ]`}
                        />
                    )}
                </Box>
            ) : (
                <Box style={{ color: 'var(--destructive)' }}>
                    {t('booking.rateNotSelected')}
                </Box>
            )}
        </>
    );
}
